import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import Logout from "./Logout";
import { getTokenInternal } from "./useToken";
import FriendIcon from "./FriendIcon";

function Nav() {
  const [token, setToken] = useState();
  const [openDropdown, setOpenDropdown] = useState(null); // Consolidated state for open dropdown
  const [gamesNameOptions, setGamesNameOptions] = useState([]);
  const navigate = useNavigate();
  const myItemsDropdownRef = useRef(null);
  const manageDropdownRef = useRef(null);

  const redirectToLogin = () => {
    navigate("/login");
  };

  const toggleDropdown = async (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);

    if (dropdownName === "MyItemTrackers" && openDropdown !== dropdownName) {
      try {
        const gamesResponse = await fetch(`${process.env.REACT_APP_API_HOST}/api/games`);
        if (!gamesResponse.ok) {
          throw new Error("Failed to fetch games");
        }
        const games = await gamesResponse.json();
        setGamesNameOptions(games);
      } catch (error) {
        console.error("Error fetching dropdown options:", error);
      }
    }
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        (myItemsDropdownRef.current && !myItemsDropdownRef.current.contains(event.target)) &&
        (manageDropdownRef.current && !manageDropdownRef.current.contains(event.target))
      ) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const fetchedToken = await getTokenInternal();
        setToken(fetchedToken);
      } catch (error) {
        console.error("Error fetching token:", error);
      }
    };

    fetchToken();
  }, []);

  return (
    <nav className="bg-black w-screen h-20 flex items-center border-b-card border-t-darker border-8">
      <Link to="/" className="flex items-center ml-10">
        <img
          src={require("../images/Unofficial.PNG")}
          alt="Loading..."
          className="h-16 shadow-lg"
        />
        <span className="text-white font-medium ml-2 hover:text-gray-400 transition duration-300">
          Home
        </span>
      </Link>
      <Link
        to="/items"
        className="text-white font-medium ml-8 hover:text-gray-400 transition duration-300"
      >
        All Items
      </Link>

      {/* My Item Trackers Dropdown */}
      <div className="relative ml-8" ref={myItemsDropdownRef}>
        <button
          onClick={() => toggleDropdown("MyItemTrackers")}
          className="text-white font-medium hover:text-gray-400 transition duration-300"
        >
          My Item Trackers
        </button>
        {openDropdown === "MyItemTrackers" && (
          <div className="absolute bg-white text-gray-800 py-2 rounded-md shadow-md mt-2">
            {gamesNameOptions.length > 0 ? (
              gamesNameOptions.map((game) => (
                <Link
                  key={game.id}
                  to={`/myitems/${game.name}`}
                  className="block px-4 py-2 hover:bg-gray-200"
                >
                  {game.name}
                </Link>
              ))
            ) : (
              <p className="px-4 py-2">No games available</p>
            )}
          </div>
        )}
      </div>

      <Link
        to="/friendlist"
        className="text-white font-medium ml-8 hover:text-gray-400 transition duration-300"
      >
        Friend's Trackers
      </Link>
      <Link to="/friends" className="flex ms-auto mr-2">
        <div>{token && <FriendIcon />}</div>
      </Link>
      <div>
        {token && (
          <Link to="/myprofile" className="flex">
            <button
              className="flex text-white font-medium hover:text-gray-400 transition duration-300"
              type="submit"
            >
              My Profile
            </button>
          </Link>
        )}
      </div>
      <div className="flex ms-auto mr-10">
        {token &&
          (token.account.role === "management" ||
            token.account.role === "owner") && (
            <Link
              to="/accounts"
              className="text-white font-medium hover:text-gray-400 transition duration-300 mr-4"
            >
              Accounts
            </Link>
          )}
        <div className="relative inline-block" ref={manageDropdownRef}>
          {token &&
            (token.account.role === "owner" ||
              token.account.role === "management" ||
              token.account.role === "helper") && (
              <div>
                <button
                  onClick={() => toggleDropdown("Manage")}
                  className="text-white font-medium hover:text-gray-400 transition duration-300"
                >
                  Manage
                </button>
              </div>
            )}
          {openDropdown === "Manage" && (
            <div className="absolute bg-white text-gray-800 py-2 rounded-md shadow-md mt-2">
              <Link
                to="/item/create"
                className="block px-4 py-2 hover:bg-gray-200"
              >
                Add Item
              </Link>
              {token &&
                (token.account.role === "management" ||
                  token.account.role === "owner") && (
                  <div>
                    <Link
                      to="/event/create"
                      className="block px-4 py-2 hover:bg-gray-200"
                    >
                      Add Event
                    </Link>
                    <Link
                      to="/types/create"
                      className="block px-4 py-2 hover:bg-gray-200"
                    >
                      Add Category
                    </Link>
                    <Link
                      to="/maps/create"
                      className="block px-4 py-2 hover:bg-gray-200"
                    >
                      Add Type
                    </Link>
                    <Link
                      to="/mapsname/create"
                      className="block px-4 py-2 hover:bg-gray-200"
                    >
                      Add Map Name
                    </Link>
                    <Link
                      to="/games/create"
                      className="block px-4 py-2 hover:bg-gray-200"
                    >
                      Add Game
                    </Link>
                    <Link
                      to="/alljunk"
                      className="block px-4 py-2 hover:bg-gray-200"
                    >
                      Check Junk
                    </Link>
                  </div>
                )}
            </div>
          )}
        </div>
        <div className="ml-4">
          {token ? (
            <Logout />
          ) : (
            <button
              onClick={redirectToLogin}
              className="text-white font-medium hover:text-gray-400 transition duration-300"
            >
              Login
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Nav;




// /* eslint-disable */
// import Logout from "./Logout";
// import { getTokenInternal } from "./useToken";
// import { useNavigate, Link } from "react-router-dom";
// import React, { useState, useEffect } from "react";
// import FriendIcon from "./FriendIcon";

// function Nav() {
//   const [token, setToken] = useState();
//   const navigate = useNavigate();

//   const redirectToLogin = () => {
//     navigate("/login");
//   };

//   const [isOpen, setIsOpen] = useState(false);

//   const toggleDropdown = () => {
//     setIsOpen(!isOpen);
//   };

//   useEffect(() => {
//     const fetchToken = async () => {
//       try {
//         const fetchedToken = await getTokenInternal();
//         setToken(fetchedToken);
//       } catch (error) {
//         console.error("Error fetching token:", error);
//       }
//     };

//     fetchToken();
//   }, []);

//   useEffect(() => {
//     if (token) {
//     }
//   }, [token]);

//   return (
//     <nav className="bg-black w-screen h-20 flex items-center border-b-card border-t-darker border-8">
//       <Link to="/" className="flex items-center ml-10">
//         <img
//           src={require("../images/Unofficial.PNG")}
//           alt="Loading..."
//           className="h-16 shadow-lg"
//         />

//         <span className="text-white font-medium ml-2 hover:text-gray-400 transition duration-300">
//           Home
//         </span>
//       </Link>
//       <Link
//         to="/items"
//         className="text-white font-medium ml-8 hover:text-gray-400 transition duration-300"
//       >
//         All Items
//       </Link>
//       <Link
//         to="/myitems/Labyrinthine"
//         className="text-white font-medium ml-8 hover:text-gray-400 transition duration-300"
//       >
//         My Item Trackers
//       </Link>
//       <Link
//         to="/friendlist"
//         className="text-white font-medium ml-8 hover:text-gray-400 transition duration-300"
//       >
//         Friend's Trackers
//       </Link>
//       <Link to="/friends" className="flex ms-auto mr-2">
//         <div>{token && <FriendIcon />}</div>
//       </Link>
//       <div>
//         {token && (
//           <Link to="/myprofile" className="flex">
//             <button
//               className="flex text-white font-medium hover:text-gray-400 transition duration-300"
//               type="submit"
//             >
//               My Profile
//             </button>
//           </Link>
//         )}
//       </div>
//       <div className="flex ms-auto mr-10">
//         {token &&
//           (token.account.role === "management" ||
//             token.account.role === "owner") && (
//             <Link
//               to="/accounts"
//               className="text-white font-medium hover:text-gray-400 transition duration-300 mr-4"
//             >
//               Accounts
//             </Link>
//           )}
//         <div className="relative inline-block">
//           {token &&
//             (token.account.role === "owner" ||
//               token.account.role === "management" ||
//               token.account.role === "helper") && (
//               <div>
//                 <button
//                   onClick={toggleDropdown}
//                   className="text-white font-medium hover:text-gray-400 transition duration-300"
//                 >
//                   Manage
//                 </button>
//               </div>
//             )}
//           {isOpen && (
//             <div className="absolute bg-white text-gray-800 py-2 rounded-md shadow-md mt-2">
//               <Link
//                 to="/item/create"
//                 className="block px-4 py-2 hover:bg-gray-200"
//               >
//                 Add Item
//               </Link>

//               {token &&
//                 (token.account.role === "management" ||
//                   token.account.role === "owner") && (
//                   <div>
//                     <Link
//                       to="/event/create"
//                       className="block px-4 py-2 hover:bg-gray-200"
//                     >
//                       Add Event
//                     </Link>
//                     <Link
//                       to="/types/create"
//                       className="block px-4 py-2 hover:bg-gray-200"
//                     >
//                       Add Category
//                     </Link>
//                     <Link
//                       to="/maps/create"
//                       className="block px-4 py-2 hover:bg-gray-200"
//                     >
//                       Add Type
//                     </Link>
//                     <Link
//                       to="/mapsname/create"
//                       className="block px-4 py-2 hover:bg-gray-200"
//                     >
//                       Add Map Name
//                     </Link>
//                     <Link
//                       to="/games/create"
//                       className="block px-4 py-2 hover:bg-gray-200"
//                     >
//                       Add Game
//                     </Link>
//                     <Link
//                       to="/alljunk"
//                       className="block px-4 py-2 hover:bg-gray-200"
//                     >
//                       Check Junk
//                     </Link>
//                   </div>
//                 )}
//             </div>
//           )}
//         </div>
//         <div className="ml-4">
//           {token ? (
//             <Logout />
//           ) : (
//             <button
//               onClick={redirectToLogin}
//               className="text-white font-medium hover:text-gray-400 transition duration-300"
//             >
//               Login
//             </button>
//           )}
//         </div>
//       </div>
//     </nav>
//   );
// }

// export default Nav;
